























import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import SlcLegalLinks from "@/components/SlcLegalLinks.vue";
import maxZIndex from "@/views/lib/useMaxZIndex";

@Component({
  components: { SlcLegalLinks },
  mounted() {
    const { height } = (this.$refs
      .legalLinksRef as Vue).$el.getBoundingClientRect();
    // @ts-ignore
    this.legalLinksHeight = height;
  }
})
export default class CdkNavigation extends Vue {
  @Prop() left!: boolean;

  @Prop() leftWidth!: number;

  legalLinksHeight = 0;

  get linksContainerStyle() {
    return {
      // Offset legal links
      height: `calc(100% - ${this.legalLinksHeight}px)`,
      overflowY: "auto"
    };
  }

  value: boolean = true;

  @Watch("left", { immediate: true })
  onLeftChange() {
    this.value = this.left;
  }

  @Watch("value", { immediate: true })
  onValueChange() {
    if (this.left !== this.value) {
      this.$emit("toggle-navigation", this.value);
    }

    setTimeout(() => {
      const overlay = document.querySelector(
        ".v-overlay.v-overlay--active"
      ) as HTMLElement;
      if (overlay) {
        overlay.style.zIndex = String(this.navDrawerZIndex);
      }
    }, 200);
  }

  get navDrawerZIndex() {
    return (
      maxZIndex.value +
      // @ts-ignore
      (this.left && this.$vuetify.breakpoint.smAndDown ? 200 : 0)
    );
  }
}
